import { render, staticRenderFns } from "./Varbox.vue?vue&type=template&id=497ba060"
import script from "./Varbox.vue?vue&type=script&lang=js"
export * from "./Varbox.vue?vue&type=script&lang=js"
import style0 from "./Varbox.vue?vue&type=style&index=0&id=497ba060&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports